import RadioButton from 'Components/Atoms/RadioButton/RadioButton';
import Text from 'Components/Atoms/Text/Text';
import Title from 'Components/Atoms/Title/Title';
import TitleGroup from 'Components/Molecules/TitleGroup/TitleGroup';
import {useEffect, useMemo} from 'react';
import {connect} from 'react-redux';
import {StoreState} from 'Store/Reducers';
import {fetchEntities} from 'Store/Settings/Entities/Actions';
import {getEntitiesById, isEntityLoading} from 'Store/Settings/Entities/Selectors';
import {fetchEntityTypesByEntityId} from 'Store/Settings/EntityTypes/Actions';
import {
    getEntityTypesByEntityIdAsObject,
    getEntityTypesByIdAsObject,
    isEntityTypesFetching
} from 'Store/Settings/EntityTypes/Selector';
import styles from './EntityTypeStep.module.sass';

const EntityTypeStep = ({
    entity, onSave, activeType, handleValidation, isConcept,

    entityTypesById, entityTypeIdsByEntityId,

    ...props
}: DisplayNameStepProps) => {
    const onComponentMount = async () => {
        props.fetchEntities();
        if (entity?.id) props.fetchEntityTypesByEntityId(entity.id);
    }

    useEffect(() => {
        onComponentMount();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    useEffect(() => {
        if (!isConcept) {
            const defaultType = entityTypeIdsByEntityId
                ?.[entity?.id]
                ?.map(i => entityTypesById?.[i])
                ?.find(i => !!i.is_default);

            processChange(defaultType?.id);
        }
    }, [isConcept]);

    const selectableTypes = useMemo(() => {
        if (!entity?.id || !entityTypeIdsByEntityId?.[entity.id] || !entityTypesById) return [];

        return entityTypeIdsByEntityId
            ?.[entity.id]
            ?.map(i => {
                const item = entityTypesById?.[i];

                return {
                    ...item,
                    icon: `fa-solid fa-${item?.name?.charAt(0)?.toLowerCase()}`,
                    name: item?.name,
                    description: item?.description
                }
            })
            ?.sort((a, b) => 
                (a.title > b.title)
                ? 1
                : -1
            );
    }, [entityTypesById, entityTypeIdsByEntityId, entity]);

    const handleClick = (id: string) => (e: any) => {
        e.preventDefault();
        processChange(id);
    };

    const processChange = (id: string) => {
        handleValidation(id);
        onSave(id);
    }

    useEffect(() => {
        handleValidation(!!activeType);
    }, [activeType]);

    return <div className={styles['entitytype']}>
        {
            selectableTypes?.map((i: any) => {
                return <div
                    className={`
                        ${styles['entitytype__item']}
                        ${i.id === activeType ? styles['entitytype__item--active'] : ''}
                    `}
                    onClick={handleClick(i.id)}
                >
                    <RadioButton
                        label={
                            <TitleGroup>
                                <Title
                                    size="inherit"
                                    transform='uppercase'
                                    weight='bold'
                                >
                                    { i.name }
                                </Title>
                                <Text color='secondary'>{ i.description }</Text>
                            </TitleGroup>
                        }
                        isActive={i.id === activeType}
                    />
                </div>;
            })
        }
    </div>
}

interface Props {
    entity: any
    onSave: any
    activeType: string
    handleValidation: any
    isConcept: boolean
};

const mapState = (state: StoreState, props: Props) => ({
    isLoading: isEntityLoading(state) || isEntityTypesFetching(state),
    
    entitiesById: getEntitiesById(state),

    entityTypesById: getEntityTypesByIdAsObject(state),
    entityTypeIdsByEntityId: getEntityTypesByEntityIdAsObject(state)
});

const mapDispatch = {
    fetchEntities,
    fetchEntityTypesByEntityId
};

type DisplayNameStepProps = Props & ReturnType<typeof mapState> & typeof mapDispatch;

export default connect(mapState, mapDispatch)(EntityTypeStep);